export const LEGAL_ENTITY_QUERY_KEYS = {
  all: (includeArchived?: boolean) => ['legal-entities', { includeArchived }] as const,
  mine: () => ['legal-entities', 'mine'] as const,
  detail: (id: string) => ['legal-entities', id] as const,
  users: (query?: string) => ['legal-entity-users', { query }] as const,
};
